import { render, staticRenderFns } from "./ApiTokens.vue?vue&type=template&id=0e1d1847&scoped=true&lang=pug&"
import script from "./ApiTokens.vue?vue&type=script&lang=js&"
export * from "./ApiTokens.vue?vue&type=script&lang=js&"
import style0 from "./ApiTokens.vue?vue&type=style&index=0&id=0e1d1847&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1d1847",
  null
  
)

/* custom blocks */
import block0 from "./ApiTokens.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports